import axios from "axios";
import {BASE_URL} from "../../settings/settings";
import {toast} from "react-toastify";
import SessionModelActions from "../../Modals/SessionExpired/SessionExpiredModal";

//Create a new axios instance with a custom config.


const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 300 * 1000,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
    },
})

axiosInstance.interceptors.response.use(response => response, error => {
    if (error?.response?.status === 401) {
        SessionModelActions.open();
    } else if (error?.response?.status === 500) {
        toast.error("Internal Server Error", {
            toastId: "internal-server-error"
        })
    }
    return Promise.reject(error);
});


export const axiosInstanceUnAuthorized = axios.create({
    baseURL: BASE_URL,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
    },
})

//Add a request interceptor


export default axiosInstance;